import { Box } from "grid-styled";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import stickybits from "stickybits";
import styled from "styled-components";
import { height, zIndex } from "styled-system";

// the Box component doesn't accept zIndex prop for some reason,
// even if adding the styled-system position function.
const ZIndexBox = styled(Box)`
  ${height}
  ${zIndex}
  pointer-events:auto;
`;

const Sticky = ({ id, offset, loading = false, children, ...otherProps }) => {
  const [calculatedOffset, setCalculatedOffset] = useState(offset);
  const stickyRef = useRef(null);

  const updateOffset = (offset, setCalculatedOffset) => {
    const bannerExists = document.querySelector("#training_environment_banner");
    if (bannerExists) {
      const newOffset = offset
        ? offset + bannerExists.offsetHeight
        : bannerExists.offsetHeight;
      setCalculatedOffset(newOffset);
    } else {
      setCalculatedOffset(offset);
    }
  };

  useLayoutEffect(() => {
    updateOffset(offset, setCalculatedOffset);
  }, [offset]);

  useEffect(() => {
    const options = {};
    if (calculatedOffset) {
      options.stickyBitStickyOffset = calculatedOffset;
    }
    stickyRef.current = stickybits(`#${id}.sticky`, options);
    const handleResize = () => {
      stickyRef.current.update();
      updateOffset(offset, setCalculatedOffset);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      stickyRef.current.cleanup();
    };
  }, [id, calculatedOffset, offset]);
  // if loading changes from true to false, recalculate
  useEffect(() => {
    if (!loading) {
      stickyRef.current.update();
    }
  }, [loading]);

  // need a unique id for each sticky component on the page
  if (!id) {
    return null;
  }

  return (
    <ZIndexBox id={id} className="sticky" {...otherProps}>
      {children}
    </ZIndexBox>
  );
};

export default Sticky;
